/**
 * Cart Drawer - Single source of truth for all cart interactions
 * Uses event delegation so handlers survive DOM replacements
 */
(function() {
  'use strict';

  const DRAWER_ID = 'cart-drawer';
  let drawer = document.getElementById(DRAWER_ID);
  if (!drawer) return;

  function open() {
    drawer = document.getElementById(DRAWER_ID);
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshDrawer();
  }

  function close() {
    drawer = document.getElementById(DRAWER_ID);
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  window.openCartDrawer = open;
  window.closeCartDrawer = close;
  window.toggleCartDrawer = function() {
    drawer = document.getElementById(DRAWER_ID);
    if (drawer && drawer.classList.contains('is-open')) close(); else open();
  };

  async function refreshDrawer() {
    try {
      var resp = await fetch(window.location.pathname, { headers: { 'Accept': 'text/html' } });
      var html = await resp.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var freshDrawer = doc.getElementById(DRAWER_ID);
      if (!freshDrawer) return;
      var panel = drawer.querySelector('.cart-drawer__panel');
      var freshPanel = freshDrawer.querySelector('.cart-drawer__panel');
      if (panel && freshPanel) {
        panel.innerHTML = freshPanel.innerHTML;
      }
    } catch (err) {
      console.error('Cart drawer refresh failed:', err);
    }
  }

  function updateHeaderCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function(el) {
      el.textContent = count;
      if (el.dataset.count !== undefined) el.dataset.count = count;
    });
    var drawerCount = document.querySelector('[data-cart-drawer-count]');
    if (drawerCount) drawerCount.textContent = count;
  }

  async function changeItem(lineKey, quantity) {
    var resp = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    });
    if (!resp.ok) throw new Error('Cart change failed');
    return resp.json();
  }

  // Backdrop / Close button
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-cart-drawer-backdrop]') || e.target.closest('[data-cart-drawer-close]')) {
      e.preventDefault();
      close();
    }
  });

  // Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') close();
  });

  // Cart icon click - open drawer instead of navigating
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href="/cart"], a[href$="/cart"], [data-cart-trigger], [data-cart-toggle]');
    if (link && !link.hasAttribute('data-skip-drawer')) {
      if (window.location.pathname === '/cart') return;
      e.preventDefault();
      open();
    }
  });

  // Add to cart form
  document.addEventListener('submit', async function(e) {
    var form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"], button:not([type="button"])');
    var origText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = '\u05de\u05d5\u05e1\u05d9\u05e3...'; }

    try {
      var resp = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
      if (!resp.ok) {
        var err = await resp.json();
        alert(err.description || '\u05e9\u05d2\u05d9\u05d0\u05d4 \u05d1\u05d4\u05d5\u05e1\u05e4\u05d4 \u05dc\u05e1\u05dc');
        return;
      }
      var cartResp = await fetch('/cart.js');
      var cart = await cartResp.json();
      updateHeaderCount(cart.item_count);
      open();
    } catch (err) {
      console.error('Add to cart error:', err);
      alert('\u05e9\u05d2\u05d9\u05d0\u05d4 \u05d1\u05d4\u05d5\u05e1\u05e4\u05d4 \u05dc\u05e1\u05dc');
    } finally {
      if (btn) {
        setTimeout(function() { btn.disabled = false; btn.textContent = origText; }, 1500);
      }
    }
  });

  // Quantity +/- buttons
  document.addEventListener('click', async function(e) {
    var minus = e.target.closest('[data-drawer-qty-minus], [data-quantity-minus]');
    var plus = e.target.closest('[data-drawer-qty-plus], [data-quantity-plus]');
    if (!minus && !plus) return;

    var btn = minus || plus;
    var lineKey = btn.dataset.lineKey;
    if (!lineKey) return;

    var item = btn.closest('[data-cart-drawer-item], [data-cart-item]');
    var qtyEl = item && (item.querySelector('[data-drawer-qty-value]') || item.querySelector('[data-quantity-input]'));
    var currentQty = qtyEl ? parseInt(qtyEl.textContent || qtyEl.value) : 1;
    var newQty = minus ? currentQty - 1 : currentQty + 1;
    if (newQty < 0) newQty = 0;

    if (item) item.classList.add('is-loading');

    try {
      var cart = await changeItem(lineKey, newQty);
      updateHeaderCount(cart.item_count);
      await refreshDrawer();
    } catch (err) {
      console.error('Quantity update error:', err);
      if (item) item.classList.remove('is-loading');
    }
  });

  // Remove item
  document.addEventListener('click', async function(e) {
    var removeBtn = e.target.closest('[data-drawer-remove-item], [data-remove-item]');
    if (!removeBtn) return;

    var lineKey = removeBtn.dataset.lineKey;
    if (!lineKey) return;

    var item = removeBtn.closest('[data-cart-drawer-item], [data-cart-item]');
    if (item) { item.classList.add('is-loading'); item.style.opacity = '0.3'; }

    try {
      var cart = await changeItem(lineKey, 0);
      updateHeaderCount(cart.item_count);
      await refreshDrawer();
    } catch (err) {
      console.error('Remove item error:', err);
      if (item) { item.classList.remove('is-loading'); item.style.opacity = ''; }
    }
  });

  // Listen for custom cart:updated event
  document.addEventListener('cart:updated', function(e) {
    var cart = e.detail && (e.detail.cart || e.detail);
    if (cart && cart.item_count !== undefined) {
      updateHeaderCount(cart.item_count);
    }
    refreshDrawer();
  });

})();
